module.exports = __webpack_public_path__ + "img/enlarge-screen.93d65298.gif";